"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var lodash_1 = require("lodash");
var react_tracking_1 = require("react-tracking");
var tracker_1 = require("@reverbdotcom/commons/dist/tracker");
var core_link_1 = require("@reverbdotcom/commons/dist/components/core_link");
var sanitized_render_1 = require("@reverbdotcom/commons/dist/components/sanitized_render");
var star_rating_1 = require("@reverbdotcom/commons/dist/components/star_rating");
var COMPONENT_NAME = 'listing_sidebar_csp_card';
var ListingSidebarCSPCard = /** @class */ (function (_super) {
    tslib_1.__extends(ListingSidebarCSPCard, _super);
    function ListingSidebarCSPCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListingSidebarCSPCard.prototype.componentDidMount = function () {
        if (this.props.csp) {
            this.trackView();
        }
    };
    ListingSidebarCSPCard.prototype.componentDidUpdate = function (oldProps) {
        if (this.props.csp && !lodash_1.isEqual(this.props.csp, oldProps.csp)) {
            this.trackView();
        }
    };
    ListingSidebarCSPCard.prototype.trackView = function () {
        this.props.tracking.trackEvent({
            eventType: tracker_1.VIEW,
            ids: [this.props.csp.id],
        });
    };
    ListingSidebarCSPCard.prototype.getCSPImageStyle = function () {
        if (!this.props.csp.image.source)
            return null;
        return { backgroundImage: "url(" + this.props.csp.image.source + ")" };
    };
    ListingSidebarCSPCard.prototype.renderPrices = function () {
        var csp = this.props.csp;
        var tags = {
            tagOpen: '<b>',
            tagClose: '</b>',
        };
        var usedLowPrice = csp.inventory.usedLowPrice;
        var newLowPrice = csp.inventory.newLowPrice;
        return (React.createElement("ul", { className: "csp-sidebar-card__prices" },
            usedLowPrice &&
                React.createElement(sanitized_render_1.default, { className: "csp-sidebar-card__price", htmlTag: "li", html: I18n.t('discovery.comparisonShoppingPages.listingSidebar.usedPriceFrom', tslib_1.__assign({ price: usedLowPrice.display }, tags)) }),
            newLowPrice &&
                React.createElement(sanitized_render_1.default, { className: "csp-sidebar-card__price", htmlTag: "li", html: I18n.t('discovery.comparisonShoppingPages.listingSidebar.newPriceFrom', tslib_1.__assign({ price: newLowPrice.display }, tags)) })));
    };
    ListingSidebarCSPCard.prototype.renderPlaceholder = function () {
        return (React.createElement("div", { className: "csp-sidebar-card csp-sidebar-card--placeholder" },
            React.createElement("div", { className: "csp-sidebar-card__inner" },
                React.createElement("div", { className: "csp-sidebar-card__content" },
                    React.createElement("div", { className: "csp-sidebar-card__content__img" },
                        React.createElement("div", { className: "csp-sidebar-card__content__img__inner" }))))));
    };
    ListingSidebarCSPCard.prototype.render = function () {
        var csp = this.props.csp;
        if (!csp)
            return this.renderPlaceholder();
        return (React.createElement("article", { className: "csp-sidebar-card" },
            React.createElement(core_link_1.default, { className: "csp-sidebar-card__inner", to: this.props.csp.webLink.href, entityId: this.props.csp.id },
                React.createElement("div", { className: "csp-sidebar-card__content" },
                    React.createElement("div", { className: "csp-sidebar-card__content__img" },
                        React.createElement("div", { className: "csp-sidebar-card__content__img__inner", style: this.getCSPImageStyle() })),
                    React.createElement("div", { className: "csp-sidebar-card__content__details" },
                        React.createElement("h4", { className: "csp-sidebar-card__content__title" }, csp.title),
                        !!this.props.csp.reviews.avgRating &&
                            React.createElement("div", { className: "mb-half" },
                                React.createElement(star_rating_1.default, { rating: this.props.csp.reviews.avgRating / 5.0, count: this.props.csp.reviews.total })),
                        this.renderPrices())),
                React.createElement("div", { className: "csp-sidebar-card__compare-cta" }, I18n.t('discovery.comparisonShoppingPages.listingSidebar.comparePrices')))));
    };
    ListingSidebarCSPCard = tslib_1.__decorate([
        react_tracking_1.default({ componentName: COMPONENT_NAME, type: tracker_1.CSP_TYPE })
    ], ListingSidebarCSPCard);
    return ListingSidebarCSPCard;
}(React.Component));
exports.default = ListingSidebarCSPCard;
//# sourceMappingURL=listing_sidebar_csp_card.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/csp/listing_sidebar_csp_card.js
// module id = CF1e
// module chunks = 20 21